import { ApiProperty } from '@nestjs/swagger';
import { ArrayMaxSize, IsArray, IsUUID } from 'class-validator';

export class PopupMostradaDto {
  @ApiProperty({ type: [String], description: 'Alertas que se le mostraron al usuario en el popup' })
  @IsArray()
  @ArrayMaxSize(100)
  @IsUUID('all', { each: true })
  ids: string[];
}
